import React, { useContext, useState } from 'react'
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import BasicDocument from './BasicDocument';
import { DataContext } from '../Context';
import './cotizacion.css'
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2'

const Cotizacion = () => {
  let location = useHistory()
  const { CartItem } = useContext(DataContext);
  const [cargando, setCargando] = useState(false);
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccion, setDireccion] = useState("");
  const total = Intl.NumberFormat('de-DE').format(CartItem.reduce((precio, item) => precio + item.qty * item.precio, 0));



  const mensajeCompletado = () => {
    Swal.fire(
      'Carga Completada!',
      'Ya puedes descargar el pdf',
      'success',
    )
  }

  const handleFrom = (e) => {
    e.preventDefault()

  }

  const getInfoForm = () => {
    setCargando(true);
  }

  const resetInfoForm = () => {
    setCargando(false)
    setNombreEmpresa("")
    setNombreCliente("")
    setDireccion("")
  }
  return (
    <div className="cotizacion_container">
      <div className='cotizacion_container_header'>


        <button className='regresarPDFButton' onClick={location.goBack}>Regresar</button>
      </div>

      <div className="explicacion_pdf_container">
        {
          cargando ? <h1>Porfavor espera que el botón cambie a color <span style={{ color: "#0877a8" }}>azul</span>, esto puede tardar un momento</h1> :
            <h1>Para generar el PDF dale click al boton "Cargar PDF"</h1>
        }
        <div className='form_container'>
          <div className='flex-form-input'>
            <label htmlFor="nombreEmpresa">Nombre Empresa (Opcional)</label>
            <input id='nombreEmpresa' type="text" style={cargando ? { cursor: "not-allowed" } : null} onChange={(e) => setNombreEmpresa(e.target.value)} disabled={cargando ? true : false} />
            {cargando ? <p style={{
              fontSize: "12px",
              color: "#e94560",
              position: "absolute",
              bottom: -20,
              right: 4,
            }}>Reinicia el PDF para volver a editar</p> : null}
          </div>
          <div className='flex-form-input'>
            <label htmlFor="nombreCliente">Nombre Cliente (Opcional)</label>
            <input id='nombreCliente' type="text" style={cargando ? { cursor: "not-allowed" } : null} onChange={(e) => setNombreCliente(e.target.value)} disabled={cargando ? true : false} />
            {cargando ? <p style={{
              fontSize: "12px",
              color: "#e94560",
              position: "absolute",
              bottom: -20,
              right: 4,
            }}>Reinicia el PDF para volver a editar</p> : null}
          </div>
          <div className='flex-form-input'>
            <label htmlFor="direccion">Número Cliente: (Opcional)</label>
            <input id='direccion' type="text" style={cargando ? { cursor: "not-allowed" } : null} onChange={(e) => setDireccion(e.target.value)} disabled={cargando ? true : false} />
            {cargando ? <p style={{
              fontSize: "12px",
              color: "#e94560",
              position: "absolute",
              bottom: -20,
              right: 4,
            }}>Reinicia el PDF para volver a editar</p> : null}
          </div>
          <div className='flex-form-button'>
            {
              cargando ?
                <PDFDownloadLink
                  document={<BasicDocument
                    CartItem={CartItem}
                    totalPriceProducts={total}
                    nombreEmpresa={nombreEmpresa}
                    nombreCliente={nombreCliente}
                    direccion={direccion}
                  />}
                  fileName="LaConsolacotización.pdf">
                  {({ blob, url, loading, error }) => (loading ?

                    <div>
                      {/* <p style={{color:"#ed9c45"}}>Cargando...</p> */}
                      <button disabled style={{ backgroundColor: "#f4a333", cursor: "not-allowed" }} className="descargarPDFButton">Cargando PDF</button>
                    </div>
                    :
                    <div onLoadStart={() => mensajeCompletado()}>
                      {/* <p style={{color:"#0877a8"}}>¡Comletado!</p> */}
                      <button style={{ backgroundColor: "#0877a8", cursor: "pointer" }} className="descargarPDFButton">Descargar PDF</button>

                    </div>
                  )}
                </PDFDownloadLink>
                :
                <button disabled={cargando ? true : false} style={cargando ? { cursor: "not-allowed", opacity: ".6" } : { cursor: "pointer" }} onClick={getInfoForm}>Cargar PDF</button>
            }

            <button onClick={resetInfoForm}>Reiniciar PDF</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cotizacion